<template>
    <div class="library_div">
        <Library></Library>
    </div>
</template>

<script type="text/javascript">
    import Library from '@/components/library_page/library.vue'

    import {mapActions} from 'vuex'

    export default {
        components: {
            Library,
        },
        methods: {
            ...mapActions({
                change_library_index: 'library/change_library_index',
                change_library_content: 'library/change_library_content'
            })
        },
        watch: {
            '$route': function () {
                this.change_library_content(this.$route.query)
            }
        },
        mounted: function () {
            this.change_library_index()
            this.change_library_content(this.$route.query)
        }
    }
</script>
<style type="text/css">

</style>
